// services/performerService.js
import api from './apiService';

export const fetchPerformers = async (communityId) => {
  try {
    const response = await api.get(`/communities/${communityId}/performers`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createPerformer = async (communityId, performerData) => {
  try {
    const response = await api.post(`/communities/${communityId}/performers`, performerData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updatePerformer = async (communityId, performerId, performerData) => {
  try {
    const response = await api.put(`/communities/${communityId}/performers/${performerId}`, performerData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deletePerformer = async (communityId, performerId) => {
  try {
    const response = await api.delete(`/communities/${communityId}/performers/${performerId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const uploadPerformerImage = async (communityId, performerId, formData) => {
  try {
    const response = await api.post(
      `/communities/${communityId}/performers/${performerId}/image`, 
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const fetchPerformerByName = async (communityId, performerName) => {
  try {
    const response = await api.get(`/communities/${communityId}/performers/by-name/${encodeURIComponent(performerName)}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};